const ROUTES_WITHOUT_TOP_BAR = ['profile', 'custom-poster'];

export const isRouteWithoutTopBar = (pathname: string) =>
  ROUTES_WITHOUT_TOP_BAR.some(str => pathname.includes(str));

